export {BeastHandler} from './beast_handler'

// import { isDevEnvironment } from './util/env'
// import runExample from './example'

// if(isDevEnvironment()){
//     runExample()
// }
